import React from 'react';
import { BottomNavigation, BottomNavigationAction, Grid, Typography } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import ListAltIcon from '@mui/icons-material//ListAlt';
import LockIcon from '@mui/icons-material//Lock';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { Link } from 'react-router-dom';

const BottomNav = () => {
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  
    return (
        <Grid container direction="column" alignItems="center">
        <Grid item>
          <BottomNavigation value={value} onChange={handleChange} showLabels>
            <BottomNavigationAction label="Home" icon={<HomeIcon />} component={Link} to="/" />
            <BottomNavigationAction label="Terms" icon={<ListAltIcon />} component={Link} to="/terms" />
            <BottomNavigationAction label="Privacy" icon={<LockIcon />} component={Link} to="/privacy" />
            <BottomNavigationAction label="Contact" icon={<ContactMailIcon />} component={Link} to="/contact" />
          </BottomNavigation>
        </Grid>
        <Grid item>
          <Typography variant="body2" paragraph gutterBottom align="center">
            @ClipThoughts 2024 All Rights Reserved
          </Typography>
        </Grid>
      </Grid>
    );
  };
  
  export default BottomNav;